import { readCookie, eraseCookie } from './cookies'

export function restoreScroll() {
  const storedLocation = readCookie('location')
  const scrollY = parseInt(readCookie('scrollYPosition') || '0', 10)

  if (isSamePage(storedLocation) && !isNaN(scrollY)) {
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollY)
    })

    eraseCookie('location')
    eraseCookie('scrollYPosition')
  }
}

function isSamePage(storedLocation) {
  if (!storedLocation) return false

  try {
    const storedUrl = new URL(storedLocation)

    return (
      storedUrl.origin === window.location.origin &&
      storedUrl.pathname === window.location.pathname
    )
  } catch {
    return false
  }
}
